import React from "react";
import { Navigate } from "react-router-dom";
import { useDataContext } from "./DataContext";
import Spinnerr from "./Spinner/Spinner";

/**
 * Regular admins see the default dashboard; Key Account Managers are sent to the KAM hub.
 */
const DashboardEntry = ({ children }) => {
  const { isKeyAccountManager, profileReady } = useDataContext();
  if (!profileReady) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center bg-[#FAFAFA]">
        <Spinnerr />
      </div>
    );
  }
  if (isKeyAccountManager) return <Navigate to="/kam/dashboard" replace />;
  return children;
};

export default DashboardEntry;
